import styled, { css } from 'styled-components'
import { tabletBreakpoint, desktopBreakpoint } from 'react-components'

type CarouselProps = {
    imageCarouselBorderRadius?: string
    horizontalCardHeight?: string
    margin?: string
}

export const CarouselContainer = styled.div<CarouselProps>(
    ({ theme, imageCarouselBorderRadius, horizontalCardHeight, margin }) => css`
        height: ${horizontalCardHeight ? horizontalCardHeight : '100%'};
        position: ${theme.style.position.relative};
        border-radius: ${imageCarouselBorderRadius ? imageCarouselBorderRadius : `0.375rem 0.375rem 0 0`};

        @media only screen and (min-width: ${tabletBreakpoint.min}px) {
            margin-right: ${theme.spacing.medium};
        }
        @media only screen and (min-width: ${desktopBreakpoint.min}px) {
            margin-right: 1.125rem;
        }
        ${!!margin && `margin: ${margin} !important`};

        /* Hide carousel buttons by default */
        ${StyledCarouselBackButton}, ${StyledCarouselNextButton} {
            opacity: 0;
            transition: opacity 200ms ease-in;
        }

        /* Show carousel buttons on hover */
        &:hover {
            ${StyledCarouselBackButton}, ${StyledCarouselNextButton} {
                opacity: 1;
            }
        }
    `,
)

export const CarouselImage = styled.div<CarouselProps>(
    ({ theme, horizontalCardHeight }) => css`
        height: ${horizontalCardHeight ? horizontalCardHeight : '100%'};
        width: ${theme.layout.fill};
        position: ${theme.style.position.relative};
        overflow: hidden;
        border-radius: ${theme.typography.border.radius.xLarge} ${theme.typography.border.radius.xLarge} 0 0;
    `,
)

export const SlidePlaceholder = styled.div<{ paddingTop?: string }>`
    padding-top: ${({ paddingTop }) => paddingTop ?? '0'};
`

export const CarouselIcon = styled.img`
    height: 1rem;
    width: 1rem;
`

export const StyledCarouselBackButton = styled.button(
    ({ theme }) => css`
        position: ${theme.style.position.absolute};
        top: 45%;
        left: 0;
        background-color: rgba(33, 33, 33, 0.6);
        box-shadow:
            0px 5px 5px 0px #00000014,
            0px 3px 14px 0px #0000000a,
            0px 8px 10px 0px #0000000f;
        border-radius: 100%;
        margin: 0 1.25rem;
        height: 2rem;
        width: 2rem;
        display: flex;
        flex-direction: ${theme.style.flexDirection.column};
        align-items: ${theme.style.alignItems.center};
        justify-content: ${theme.style.justifyContent.center};
        opacity: 1;
        z-index: 10;
        border: none;
        cursor: pointer;
        transform: translateY(-50%);

        svg path {
            stroke: white;
        }

        svg {
            min-width: 1.5rem;
            min-height: 1.5rem;
        }

        &:hover {
            opacity: 1 !important;
            transition: opacity 200ms ease-in;
        }
    `,
)

export const StyledCarouselNextButton = styled(StyledCarouselBackButton)`
    left: unset;
    right: 0;
`
